<template>
    <select :data-key="key" class="form-select kt_select2" data-control="select2"
      :v-model="selectedItem" :name="selectName"
      data-placeholder="Selectionnez" data-allow-clear="false">
      <option></option>
      <option v-for="(item, index) in items" :key="index" :value="item.id">
        <span v-if="type='product'">
          {{ item.name }}{{ formatProduct(item) }}
        </span>
        <span v-else>
          {{ item.iso }}
        </span>

      </option>
    </select>
  </template>
  
  <script>
  export default {
    props: {
      key: {
        type: Number,
        required: true
      },
      items: {
        type: Array,
        required: true
      },
      selectedItem:{
        type: String,
        required: true
      },
      selectName:{
        type: String,
        required: true
      },
      type:{
        type: String,
        required: true
      }
    },
    methods: {
      formatProduct(product) {
        // return (product.attribut.length > 0) ? ' (' + product.attribut + ')' : '';
      }
    }
  }
  </script>
  